import { render, staticRenderFns } from "./OvrdAcctNoHelpList.vue?vue&type=template&id=319e55f2&"
import script from "./OvrdAcctNoHelpList.vue?vue&type=script&lang=js&"
export * from "./OvrdAcctNoHelpList.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports